import { render, staticRenderFns } from "./search_box_by_click.vue?vue&type=template&id=912c1c84"
import script from "./search_box_by_click.vue?vue&type=script&lang=js"
export * from "./search_box_by_click.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports